import type { Role } from '@/stores/useSessionStore'

const IDENTITY_ROLE_MAP: Record<string, Role> = {
  SUPER_ADMIN: 'PLATFORM_ADMIN',
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  MANAGER: 'EDITOR',
  VIEWER: 'VIEWER',
  RECRUITER: 'VIEWER',
  INTERVIEWER: 'VIEWER',
  USER: 'VIEWER',
}

/**
 * Roles that belong exclusively to the Signal Provider portal.
 * If `/me` returns one of these, this session must not be accepted
 * by the Sensemaker app — the user is logged into the wrong portal.
 */
const PROVIDER_ONLY_ROLES = new Set(['SIGNAL_PROVIDER', 'PARTICIPANT'])

/** True when the identity role is a Signal Provider role (wrong app for Sensemaker). */
export function isProviderRole(role: string): boolean {
  return PROVIDER_ONLY_ROLES.has(role)
}

/**
 * Maps identity `/auth/me` role + permissions into a Sensemaker session role.
 * Returns `null` for any role that is not recognised as a Sensemaker role —
 * callers MUST reject null (do not fall back to a permissive default).
 */
export function mapIdentityRoleToSensemaker(
  role: string,
  permissions: string[] | undefined
): Role | null {
  if (permissions?.includes('SUPER_ADMIN')) {
    return 'PLATFORM_ADMIN'
  }
  return IDENTITY_ROLE_MAP[role] ?? null
}
